<template>
  <ClientOnly>
    <nav>
      <div class="wrapper backButtonWrapper">
        <a class="backButton" @click.prevent="go(-1)"
          ><IconArrowRight /> Назад</a
        >
      </div>
    </nav>
  </ClientOnly>
</template>

<script setup>
const { go } = useRouter();
</script>
